export const DownloadIcon: React.FC<{ size?: number; color?: string }> = ({
  size,
  color,
}) => (
  <svg
    width={size || 14}
    height={size || 14}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color || "currentColor"}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3v12" />
    <path d="M7 11l5 4 5-4" />
    <path d="M4 20h16" />
  </svg>
);
